var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.099,
    height: 104,
    viewBox: "0 0 104.099 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_872",
    x: 81.56,
    y: 33.719,
    width: 22.439,
    height: 29.151,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_873",
    x: 55.346,
    y: 77.458,
    width: 26.885,
    height: 24.029,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_874",
    x: 69.536,
    y: 66.47,
    width: 25.663,
    height: 26.051,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_875",
    x: 78.719,
    y: 52.273,
    width: 23.675,
    height: 27.051,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_876",
    x: 0,
    y: 0,
    width: 104.099,
    height: 104,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_877",
    x: 22.483,
    y: 14.957,
    width: 40.386,
    height: 66.609,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2197ed"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(-647 -156)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647, 156)",
    filter: "url(#Path_872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872-2",
    "data-name": "Path 872",
    d: "M26.579,11.6a1.9,1.9,0,0,0-3.739.636,40.717,40.717,0,0,1,.673,7.067,1.87,1.87,0,1,0,3.739,0,44.01,44.01,0,0,0-.673-7.7Z",
    transform: "translate(67.75 32.7)",
    fill: "#2197ed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647, 156)",
    filter: "url(#Path_873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873-2",
    "data-name": "Path 873",
    d: "M21.964,21.881a36.232,36.232,0,0,1-4.6,2.094,1.9,1.9,0,0,0,.673,3.739,2.131,2.131,0,0,0,.673,0,50.254,50.254,0,0,0,5.01-2.281,1.907,1.907,0,0,0,.748-2.543,1.87,1.87,0,0,0-2.505-1.01Z",
    transform: "translate(48.54 64.74)",
    fill: "#2197ed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647, 156)",
    filter: "url(#Path_874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874-2",
    "data-name": "Path 874",
    d: "M23.908,19.611a37.391,37.391,0,0,1-3.739,4,1.87,1.87,0,0,0,1.309,3.216,1.832,1.832,0,0,0,1.309-.523A39.859,39.859,0,0,0,26.75,21.93a1.87,1.87,0,1,0-2.917-2.318Z",
    transform: "translate(58.94 56.69)",
    fill: "#2197ed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647, 156)",
    filter: "url(#Path_875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875-2",
    "data-name": "Path 875",
    d: "M26.417,15.055A1.87,1.87,0,0,0,24.1,16.326a37.39,37.39,0,0,1-1.87,5.2,1.832,1.832,0,0,0,.935,2.468,1.8,1.8,0,0,0,.748,0,1.87,1.87,0,0,0,1.72-1.122,44.382,44.382,0,0,0,2.057-5.646A1.87,1.87,0,0,0,26.417,15.055Z",
    transform: "translate(65.67 46.29)",
    fill: "#2197ed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647, 156)",
    filter: "url(#Path_876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876-2",
    "data-name": "Path 876",
    d: "M81.391,27.174h.262a1.87,1.87,0,0,0,.748-.3h.187a2.991,2.991,0,0,0,.673-.935h0L87,14.723a1.969,1.969,0,1,0-3.739-1.234l-2.43,7.216A43.785,43.785,0,0,0,44,1a43,43,0,1,0,0,86,47.19,47.19,0,0,0,5.16-.3A1.907,1.907,0,0,0,50.8,84.607,1.87,1.87,0,0,0,48.711,83,39.261,39.261,0,1,1,44,4.74a39.784,39.784,0,0,1,34.1,18.7H70.173a1.87,1.87,0,1,0,0,3.739Z",
    transform: "translate(8 8)",
    fill: "#2197ed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 647, 156)",
    filter: "url(#Path_877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877-2",
    "data-name": "Path 877",
    d: "M25.66,6.87V33.417L7.563,50.393a1.832,1.832,0,0,0,0,2.617,1.72,1.72,0,0,0,1.271.6,1.683,1.683,0,0,0,1.271-.523l18.7-17.5a1.8,1.8,0,0,0,.6-1.346V6.87a1.87,1.87,0,0,0-3.739,0Z",
    transform: "translate(24.47 18.96)",
    fill: "#2197ed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.c775300c2cc296e6f757e80a7957f0ea.svg";
export { ForwardRef as ReactComponent };